import React from 'react';
import ReactDOM from 'react-dom/client';
import Tilventis from './Tilventis';
import './normalize.css';
import './index.css';
import './langs/i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Tilventis />
  </React.StrictMode>
);

